<template>
  <div class="autoLogin">
    <div>
      <div class="login-loading">
        <div class="loader-inner ball-scale-multiple">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <p>正在跳转请稍后...</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {setWeixInfo} from "@/utils/auth";

export default {
  name: 'autoLogin',
  data() {
    return{
      text: ''
    }
  },
  methods: {
    setInfo(){
      if (this.$route.query.key){
        axios.post(`${process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API}/BizMemberMember/DetailsByKey`,{}, {
          headers: {
            Key: this.$route.query.key
          }
        }).then(({data}) => {
          console.log(data)
          if (data.Status === 1) {
            setWeixInfo(data.Data)
            setTimeout(() => {
              this.$router.replace({name: 'home'})
            }, 2000)
          }else {
            this.$dialog.alert({title: '标题', message: '未找到有效信息'}).then(() => {})
          }
        })
      }
    }
  },
  mounted() {
    this.setInfo()
  }
}


</script>

<style scoped lang="less">
.autoLogin{
  position: absolute;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background: #fff !important;
  padding: .3rem;
  >div{
    width: 150px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    .login-loading{
      width: 60px;
      height: 60px;
      margin: 0 auto;
    }
    p{
      line-height: 1rem;
      font-size: .28rem;
      color: #409EFF;
    }
  }
}
</style>
